// extracted by mini-css-extract-plugin
export var modal = "_ts-0";
export var table = "_ts-1";